import { logoutAPI } from "../services/authService";
import SchoolStorage from "../utils/localStorage";
import useAuth from "./useAuth";

const useLogout = () => {
  const { setAuth, setSchool } = useAuth();

  const logout = async () => {
    try {
      await logoutAPI();
    } catch (err) {
      // 
    } finally {
      setAuth({});
      setSchool({});
      SchoolStorage.clearSchool();
    }
  };

  return logout;
};

export default useLogout;
